import { useAuthStore } from '../store/authStore'
import { userHasPermission, type Permission } from '../lib/permissions'

/**
 * Returns a `can(permission)` predicate bound to the current admin user.
 * Use to gate buttons/sections: `const can = useCan(); can('orders.assign')`.
 */
export function useCan() {
  const user = useAuthStore((state) => state.user)
  return (permission: Permission) => userHasPermission(user, permission)
}

/** Convenience hook for a single permission check. */
export function useHasPermission(permission: Permission): boolean {
  const user = useAuthStore((state) => state.user)
  return userHasPermission(user, permission)
}
